import axios from 'axios';

const RESSOURCE_NAME = 'types';


export default {
    getAllTypes() {
        return axios.get(`${RESSOURCE_NAME}`);
    }
};